// hide and show quick donate pop
export const SHOW_QUICK_DONATE_POP = "SHOW_QUICK_DONATE_POP";
export const HIDE_QUICK_DONATE_POP = "HIDE_QUICK_DONATE_POP";

// news list
export const GET_NEWS_LIST_LOADING = "GET_NEWS_LIST_LOADING";
export const GET_NEWS_LIST_SUCCESS = "GET_NEWS_LIST_SUCCESS";
export const GET_NEWS_LIST_FAILURE = "GET_NEWS_LIST_FAILURE";

// news list
export const GET_SINGLE_NEWS_LOADING = "GET_SINGLE_NEWS_LOADING";
export const GET_SINGLE_NEWS_SUCCESS = "GET_SINGLE_NEWS_SUCCESS";
export const GET_SINGLE_NEWS_FAILURE = "GET_SINGLE_NEWS_FAILURE";

// orphan sponsership list
export const GET_ORPHANS_LIST_LOADING = "GET_ORPHANS_LIST_LOADING";
export const GET_ORPHANS_LIST_SUCCESS = "GET_ORPHANS_LIST_SUCCESS";
export const GET_ORPHANS_LIST_FAILURE = "GET_ORPHANS_LIST_FAILURE";

// regestration lists
// countries
export const GET_COUNTRIES_LOADING = "GET_COUNTRIES_LOADING";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILURE = "GET_COUNTRIES_FAILURE";

// cities
export const GET_CITIES_LOADING = "GET_CITIES_LOADING";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_FAILURE = "GET_CITIES_FAILURE";

// titles
export const GET_TITLES_LOADING = "GET_TITLES_LOADING";
export const GET_TITLES_SUCCESS = "GET_TITLES_SUCCESS";
export const GET_TITLES_FAILURE = "GET_TITLES_FAILURE";

// register new user
export const USER_REGISTER_LOADING = "USER_REGISTER_LOADING";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAILURE = "USER_REGISTER_FAILURE";

// user login
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

// campaign list
export const CAMPAIGN_LIST_LOADING = "CAMPAIGN_LIST_LOADING";
export const CAMPAIGN_LIST_SUCCESS = "CAMPAIGN_LIST_SUCCESS";
export const CAMPAIGN_LIST_FAILURE = "CAMPAIGN_LIST_FAILURE";

// seasonal projects list
export const SEASONAL_PROJECTS_LIST_LOADING = "SEASONAL_PROJECTS_LIST_LOADING";
export const SEASONAL_PROJECTS_LIST_SUCCESS = "SEASONAL_PROJECTS_LIST_SUCCESS";
export const SEASONAL_PROJECTS_LIST_FAILURE = "SEASONAL_PROJECTS_LIST_FAILURE";

// INTERNAL projects list
export const INTERNAL_PROJECTS_LIST_LOADING = "INTERNAL_PROJECTS_LIST_LOADING";
export const INTERNAL_PROJECTS_LIST_SUCCESS = "INTERNAL_PROJECTS_LIST_SUCCESS";
export const INTERNAL_PROJECTS_LIST_FAILURE = "INTERNAL_PROJECTS_LIST_FAILURE";

// Humanitarian Cases list
export const HUMANITARIAN_CASES_LIST_LOADING =
  "HUMANITARIAN_CASES_LIST_LOADING";
export const HUMANITARIAN_CASES_LIST_SUCCESS =
  "HUMANITARIAN_CASES_LIST_SUCCESS";
export const HUMANITARIAN_CASES_LIST_FAILURE =
  "HUMANITARIAN_CASES_LIST_FAILURE";

// DONATION project detail by id list
export const DONATION_PROJECT_DETAILS_BY_ID_LOADING =
  "DONATION_PROJECT_DETAILS_BY_ID_LOADING";
export const DONATION_PROJECT_DETAILS_BY_ID_SUCCESS =
  "DONATION_PROJECT_DETAILS_BY_ID_SUCCESS";
export const DONATION_PROJECT_DETAILS_BY_ID_FAILURE =
  "DONATION_PROJECT_DETAILS_BY_ID_FAILURE";

// HUMAN_ project detail by id list
export const HUMAN_PROJECT_DETAILS_BY_ID_LOADING =
  "HUMAN_PROJECT_DETAILS_BY_ID_LOADING";
export const HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS =
  "HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS";
export const HUMAN_PROJECT_DETAILS_BY_ID_FAILURE =
  "HUMAN_PROJECT_DETAILS_BY_ID_FAILURE";

// RECENT_ project detail by id list
export const RECENT_PROJECT_DETAILS_BY_ID_LOADING =
  "RECENT_PROJECT_DETAILS_BY_ID_LOADING";
export const RECENT_PROJECT_DETAILS_BY_ID_SUCCESS =
  "RECENT_PROJECT_DETAILS_BY_ID_SUCCESS";
export const RECENT_PROJECT_DETAILS_BY_ID_FAILURE =
  "RECENT_PROJECT_DETAILS_BY_ID_FAILURE";

// news letter
export const NEWS_LETTER_EMAIL_LOADING = "NEWS_LETTER_EMAIL_LOADING";
export const NEWS_LETTER_EMAIL_SUCCESS = "NEWS_LETTER_EMAIL_SUCCESS";
export const NEWS_LETTER_EMAIL_FAILURE = "NEWS_LETTER_EMAIL_FAILURE";

// contact us
export const CONTACT_US_LOADING = "CONTACT_US_LOADING";
export const CONTACT_US_SUCCESS = "CONTACT_US_SUCCESS";
export const CONTACT_US_FAILURE = "CONTACT_US_FAILURE";

// videos
export const VIDEOS_LOADING = "VIDEOS_LOADING";
export const VIDEOS_SUCCESS = "VIDEOS_SUCCESS";
export const VIDEOS_FAILURE = "VIDEOS_FAILURE";

// Cart
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";

// user add cart items
export const USER_ADD_CART_ITEMS_LOADING = "USER_ADD_CART_ITEMS_LOADING";
export const USER_ADD_CART_ITEMS_SUCCESS = "USER_ADD_CART_ITEMS_SUCCESS";
export const USER_ADD_CART_ITEMS_FAILURE = "USER_ADD_CART_ITEMS_FAILURE";

// user adjust cart item
export const USER_ADJUST_CART_ITEM_LOADING = "USER_ADJUST_CART_ITEM_LOADING";
export const USER_ADJUST_CART_ITEM_SUCCESS = "USER_ADJUST_CART_ITEM_SUCCESS";
export const USER_ADJUST_CART_ITEM_FAILURE = "USER_ADJUST_CART_ITEM_FAILURE";

// user get cart items
export const USER_GET_CART_ITEMS_LOADING = "USER_GET_CART_ITEMS_LOADING";
export const USER_GET_CART_ITEMS_SUCCESS = "USER_GET_CART_ITEMS_SUCCESS";
export const USER_GET_CART_ITEMS_FAILURE = "USER_GET_CART_ITEMS_FAILURE";

// user get cart items
export const USER_Delete_CART_ITEMS_LOADING = "USER_Delete_CART_ITEMS_LOADING";
export const USER_Delete_CART_ITEMS_SUCCESS = "USER_Delete_CART_ITEMS_SUCCESS";
export const USER_Delete_CART_ITEMS_FAILURE = "USER_Delete_CART_ITEMS_FAILURE";

///////////////////////////// sms donation
export const SMS_DONATION_LOADING = "SMS_DONATION_LOADING";
export const SMS_DONATION_SUCCESS = "SMS_DONATION_SUCCESS";
export const SMS_DONATION_FAILURE = "SMS_DONATION_FAILURE";

// quick donate types
export const QUICK_DONATE_LOADING = "QUICK_DONATE_LOADING";
export const QUICK_DONATE_SUCCESS = "QUICK_DONATE_SUCCESS";
export const QUICK_DONATE_FAILURE = "QUICK_DONATE_FAILURE";

// payment api
export const REQUEST_SECURE_URL_LOADING = "REQUEST_SECURE_URL_LOADING";
export const REQUEST_SECURE_URL_SUCCESS = "REQUEST_SECURE_URL_SUCCESS";
export const REQUEST_SECURE_URL_FAILURE = "REQUEST_SECURE_URL_FAILURE";

// donation history
export const DONATION_HISTORY_LOADING = "DONATION_HISTORY_LOADING";
export const DONATION_HISTORY_SUCCESS = "DONATION_HISTORY_SUCCESS";
export const DONATION_HISTORY_FAILURE = "DONATION_HISTORY_FAILURE";

// reset password
export const GENERATE_OTP_RESET_PASSWORD_LOADING =
  "GENERATE_OTP_RESET_PASSWORD_LOADING";
export const GENERATE_OTP_RESET_PASSWORD_SUCCESS =
  "GENERATE_OTP_RESET_PASSWORD_SUCCESS";
export const GENERATE_OTP_RESET_PASSWORD_FAILURE =
  "GENERATE_OTP_RESET_PASSWORD_FAILURE";

export const VALIDATE_OTP_RESET_PASSWORD_LOADING =
  "VALIDATE_OTP_RESET_PASSWORD_LOADING";
export const VALIDATE_OTP_RESET_PASSWORD_SUCCESS =
  "VALIDATE_OTP_RESET_PASSWORD_SUCCESS";
export const VALIDATE_OTP_RESET_PASSWORD_FAILURE =
  "VALIDATE_OTP_RESET_PASSWORD_FAILURE";

export const RESET_PASSWORD_LOADING = "RESET_PASSWORD_LOADING";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

// PAYMENT STAUTS

export const PAYMENT_STATUS_LOADING = "PAYMENT_STATUS_LOADING";
export const PAYMENT_STATUS_SUCCESS = "PAYMENT_STATUS_SUCCESS";
export const PAYMENT_STATUS_FAILURE = "PAYMENT_STATUS_FAILURE";

/////////////////////////////////////////
/////////////////////////////////////////
/////////////////////////////////////////
/////////////////////////////////////////
/////////////////////////////////////////
//external projects

// getting categories
export const GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING =
  "GET_EXTERNAL_PROJECTS_CATEGORIES_LOADING";
export const GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS =
  "GET_EXTERNAL_PROJECTS_CATEGORIES_SUCCESS";
export const GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE =
  "GET_EXTERNAL_PROJECTS_CATEGORIES_FAILURE";

// getting sub categories
export const GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING =
  "GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_LOADING";
export const GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS =
  "GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_SUCCESS";
export const GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE =
  "GET_EXTERNAL_PROJECTS_SUB_CATEGORIES_FAILURE";

// get external projects countries
export const GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING =
  "GET_EXTERNAL_PROJECTS_COUNTRIES_LOADING";
export const GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS =
  "GET_EXTERNAL_PROJECTS_COUNTRIES_SUCCESS";
export const GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE =
  "GET_EXTERNAL_PROJECTS_COUNTRIES_FAILURE";

// get external projects list
export const GET_EXTERNAL_PROJECTS_LIST_LOADING =
  "GET_EXTERNAL_PROJECTS_LIST_LOADING";
export const GET_EXTERNAL_PROJECTS_LIST_SUCCESS =
  "GET_EXTERNAL_PROJECTS_LIST_SUCCESS";
export const GET_EXTERNAL_PROJECTS_LIST_FAILURE =
  "GET_EXTERNAL_PROJECTS_LIST_FAILURE";

// getting details
export const GET_EXTERNAL_PROJECTS_DETIALS_LOADING =
  "GET_EXTERNAL_PROJECTS_DETIALS_LOADING";
export const GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS =
  "GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS";
export const GET_EXTERNAL_PROJECTS_DETIALS_FAILURE =
  "GET_EXTERNAL_PROJECTS_DETIALS_FAILURE";
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
/////  user profile

// get user profile details
export const GET_USER_DETAILS_BY_USER_ID_LOADING =
  "GET_USER_DETAILS_BY_USER_ID_LOADING";
export const GET_USER_DETAILS_BY_USER_ID_SUCCESS =
  "GET_USER_DETAILS_BY_USER_ID_SUCCESS";
export const GET_USER_DETAILS_BY_USER_ID_FAILURE =
  "GET_USER_DETAILS_BY_USER_ID_FAILURE";

// update user profile details
export const UPDATE_USER_DETAILS_BY_USER_ID_LOADING =
  "UPDATE_USER_DETAILS_BY_USER_ID_LOADING";
export const UPDATE_USER_DETAILS_BY_USER_ID_SUCCESS =
  "UPDATE_USER_DETAILS_BY_USER_ID_SUCCESS";
export const UPDATE_USER_DETAILS_BY_USER_ID_FAILURE =
  "UPDATE_USER_DETAILS_BY_USER_ID_FAILURE";
